<template>
  <div class="header-box">
	  <div class="header-box-left">
		  <div v-if="sourceType == 1" class="icon">
		    <img src="../../../assets/back/charticon.png" alt="" />
		  </div>
		  <div v-else class="line"></div>
		  <div class="title">{{ title }}</div>
	  </div>
    <div class="header-box-right">
		<slot name='left'></slot>
	</div>
	
  </div>
</template>
<script>
export default {
  props: {
    title: {
      typeof: String,
      default: '',
    },
    sourceType: {
      typeof: [String, Number],
      default: 1,
    },
  },
  data() {
    return {}
  },
  watch: {},
  created() {},
  methods: {},
}
</script>
<style scoped lang="scss">
.header-box {
  display: flex;
  justify-content: space-between;
  height: 20px;
  display: flex;
  align-items: center;
  .header-box-left{
	  flex: 1;
	  display: flex;
	  align-items: center;
  }
  .icon {
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    margin-right: 10px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .line{
      width: .1125rem;
      height: .2rem;
      background: #EFAB44;
      border-radius: .025rem;
      margin-right: 10px;
    }
  .title {
    height: 20px;
    font-size: 16px;
    font-family: Source Han Sans, Source Han Sans;
    font-weight: 500;
    color: #efab44;
    display: flex;
    align-items: center;
  }
}
</style>
